import CityPageTemplate from "../city-template/CityPageTemplate";
import { durhamNhConfig } from "./data";

export default function DurhamNHPage() {
  return <CityPageTemplate config={durhamNhConfig} />;
}